import { useMutation } from 'react-query';
import axios from 'axios';

const useMutate = ({ api, options = {} }) => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/${api}`, payload);

      if (response?.data?.status !== 200) {
        throw new Error('Terjadi kesalahan di server');
      }

      return response?.data;
    },
    ...options
  });
};

export default useMutate;
